import { Delete } from 'lucide-react';

type Props = {
  onNumClick: (num: string) => void;
  onClear: () => void;
  onDelete: () => void;
};

export const NumericKeypad = ({ onNumClick, onClear, onDelete }: Props) => {
  return (
    <div className="h-full w-full bg-slate-200 overflow-hidden">
      <div className="grid grid-cols-3 grid-rows-4 gap-[1px] h-full w-full">
        {[7, 8, 9, 4, 5, 6, 1, 2, 3].map((num) => (
          <button
            key={num}
            onClick={() => onNumClick(num.toString())}
            className="bg-white hover:bg-slate-50 active:bg-slate-200 text-3xl font-bold text-slate-700 flex items-center justify-center transition-colors touch-manipulation"
          >
            {num}
          </button>
        ))}

        <button
          onClick={onClear}
          className="bg-slate-300 hover:bg-slate-400 active:bg-slate-500 text-slate-700 font-bold flex flex-col items-center justify-center gap-1 touch-manipulation"
        >
          <span className="text-lg">クリア</span>
        </button>

        <button
          onClick={() => onNumClick('0')}
          className="bg-white hover:bg-slate-50 active:bg-slate-200 text-3xl font-bold text-slate-700 flex items-center justify-center touch-manipulation"
        >
          0
        </button>

        <button
          onClick={onDelete}
          className="bg-slate-300 hover:bg-slate-400 active:bg-slate-500 text-slate-700 flex items-center justify-center touch-manipulation"
        >
          <Delete className="w-8 h-8" />
        </button>
      </div>
    </div>
  );
};